import OWContainer from 'styles/styled-components/ow-container';
import { ProductForm } from '../components/product-form';
import { Spinner } from 'components/design';
import useController from '../controllers/add-product-controller';
import SelectNestedProductDialog from '../components/select-nested-products-dialog';

export const AddProductRoute = () => {
    const {
        formData,
        places,
        productCategories,
        onSubmit,
        onCancel,
        onChange,
        isLoading,
        isAddProductLoading,
        errors,
        isAdmin,
        websiteId,
        individualPrices,
        onSelectConfigChange,
        setIndividualPrices,
        placeConfigData,
        onConfigPriceChange,
        placeId,
        nestedCategoriesWithNestedProducts,
        isSelectedNestedProductsDialogOpen,
        toggleSelectedNestedProductsDialog,
        onSelectNestedProductComplete,
        selectedNestedProducts,
    } = useController();

    return (
        <OWContainer>
            {isLoading ? (
                <Spinner />
            ) : (
                <ProductForm
                    formData={formData}
                    places={places}
                    productCategories={productCategories}
                    onSubmit={onSubmit}
                    onCancel={onCancel}
                    onChange={onChange}
                    isSaveLoading={isAddProductLoading}
                    errors={errors}
                    isAdmin={isAdmin}
                    websiteId={websiteId}
                    individualPrices={individualPrices}
                    onSelectConfigChange={onSelectConfigChange}
                    setIndividualPrices={setIndividualPrices}
                    placeConfigData={placeConfigData}
                    onConfigPriceChange={onConfigPriceChange}
                    placeId={placeId}
                    toggleSelectNestedProductDialog={toggleSelectedNestedProductsDialog}
                    selectedNestedProducts={selectedNestedProducts}
                />
            )}
            {isSelectedNestedProductsDialogOpen && (
                <SelectNestedProductDialog
                    isOpen={isSelectedNestedProductsDialogOpen}
                    toggleDialog={toggleSelectedNestedProductsDialog}
                    nestedProductCategoriesWithProducts={nestedCategoriesWithNestedProducts}
                    onSelectNestedProductComplete={onSelectNestedProductComplete}
                    initalSelectedNestedProducts={selectedNestedProducts}
                />
            )}
        </OWContainer>
    );
};
